import { MyThunkResult } from 'store';

import {
  companyConfigurationRequest,
  companyConfigurationSuccessful,
  companyConfigurationError,
} from 'action-creators/companyConfiguration';
import { CompanyConfiguration } from 'models/company';
import { Response } from 'models/response';

import { axiosConfig, profile } from '../api';

export const getCompanyConfiguration =
  (companyId: string): MyThunkResult<Promise<CompanyConfiguration | undefined>> =>
  async (dispatch) => {
    try {
      dispatch(companyConfigurationRequest());

      const { data } = await profile.get<Response<CompanyConfiguration>>(
        `/CompanyConfiguration/${companyId}`,
        axiosConfig,
      );
      console.log('getCompanyConfiguration', data);
      dispatch(companyConfigurationSuccessful(data));

      return data.data;
    } catch (ex) {
      dispatch(companyConfigurationError(ex));
    }
  };

export const getCompanyConfigurationByUpdate = async (companyId: string) =>
  profile.get<Response<CompanyConfiguration>>(`/CompanyConfiguration/${companyId}`, axiosConfig);

export const applyConfiguration =
  (config: CompanyConfiguration): MyThunkResult<Promise<CompanyConfiguration | undefined>> =>
  async (dispatch) => {
    try {
      const data: Response<CompanyConfiguration> = {
        data: config,
        succeeded: true,
        errors: [],
      };
      dispatch(companyConfigurationSuccessful(data));

      return config;
    } catch (ex) {
      dispatch(companyConfigurationError(ex));
    }
  };

export const getCompanyConfigurationFromDomain =
  (domain: string): MyThunkResult<Promise<CompanyConfiguration | undefined>> =>
  async (dispatch) => {
    try {
      dispatch(companyConfigurationRequest());

      const { data } = await profile.post<Response<CompanyConfiguration>>(
        '/CompanyConfiguration',
        { url: domain },
        axiosConfig,
      );

      dispatch(companyConfigurationSuccessful(data));

      return data.data;
    } catch (ex) {
      dispatch(companyConfigurationError(ex));
    }
  };

export const updateCompanyConfiguration =
  (config: CompanyConfiguration, companyId): MyThunkResult<Promise<any | undefined>> =>
  async (dispatch) => {
    console.log(config,)
    try {

      const { data } = await profile.put<Response<any>>('/CompanyConfiguration', config, axiosConfig,);

      await dispatch(getCompanyConfiguration(companyId));

      return data.data;
    } catch (ex) {

      alert('error on update Company Configuration');
      return undefined;
    }
  };

export const updateCompanyConfigurationBKP =
  (config: CompanyConfiguration): MyThunkResult<Promise<any | undefined>> =>
  async (dispatch) => {
    try {
      //dispatch(companyConfigurationRequest());

      const { data } = await profile.put<Response<any>>(
        '/CompanyConfiguration',
        {
          companyId: config.companyId,
          branchCodeNetactica: config.branchCodeNetactica,
          businessUnitNetactica: config.businessUnitNetactica,
          countryCode: config.countryCode,
          companyDocumentNumberNetactica: config.companyDocumentNumberNetactica,
          profileDocumentNumberNetactica: config.profileDocumentNumberNetactica,
          passportDocumentNumberNetactica: config.passportDocumentNumberNetactica,
          apiBaseUrl: config.apiBaseUrl,
          tokenexUrls: config.tokenexUrls,
          primaryBackgroundColor: config.primaryBackgroundColor,
          primaryColor: config.primaryColor,
          script3CX: config.script3CX,
          secondaryBackgroundColor: config.secondaryBackgroundColor,
          secondaryColor: config.secondaryColor,
          tertiaryBackgroundColor: config.tertiaryBackgroundColor,
          tertiaryColor: config.tertiaryColor,
          imageLogo: config.imageLogo,
          companyName: config.companyName,
          email: config.email,
          phone: config.phone,
          whatsapp: config.whatsapp,
          termsAndConditionsURL: config.termsAndConditionsURL,
          privacyPoliciesURL: config.privacyPoliciesURL,
          ownerCompanyName: config.ownerCompanyName,
          ownerImageLogo: config.ownerImageLogo,
          currencyCode: config.currencyCode,
          alternativeCurrencyCode: config.alternativeCurrencyCode,
          emailFooter: config.emailFooter,
          emailFooterBackground: config.emailFooterBackground,
          emailFooterColor: config.emailFooterColor,
          emailBodyTextColor: config.emailBodyTextColor,
          emailButtonColor: config.emailButtonColor,
          emailButtonText: config.emailButtonText,
          twilioWhatsappNumberFrom: config.twilioWhatsappNumberFrom,
          emailDisplayEmail: config.emailDisplayEmail,
          emailDisplayName: config.emailDisplayName,
          sendCopyVoucher: config.sendCopyVoucher,
          notSendVoucherOthersFlightPassenger: config.notSendVoucherOthersFlightPassenger,
          nationalAirBySector: config.nationalAirBySector,
          internationalAirBySector: config.internationalAirBySector,
          menuView: {
            hideAirFlow: config.menuView.hideAirFlow,
            hideHotelFlow: config.menuView.hideHotelFlow,
            hideVehicleFlow: config.menuView.hideVehicleFlow,
            hideExpenses: config.menuView.hideExpenses,
            hideWhatsapp: config.menuView.hideWhatsapp,
            hideCostCenter: config.menuView.hideCostCenter,
            hideReports: config.menuView.hideReports,
            hideTravelReason: config.menuView.hideTravelReason
          },
          stylesPersonalization: {
            javascriptUrl: config.stylesPersonalization.javascriptUrl,
            CssUrl: config.stylesPersonalization.cssUrl,
          },
        },
        axiosConfig,
      );

      //dispatch(companyConfigurationSuccessful(data));

      return data.data;
    } catch (ex) {
      
      //dispatch(companyConfigurationError(ex));
      alert('error on update Company Configuration');
      return undefined;
    }
  };
